/// <reference types="vite/client" />
import { Middleware, Runtime } from "polymatic";

import { OutlinePlugin } from "../space/OutlinePanel";
import { Playbook } from "@piqnt/runtime-core/playbook";

import { ToolbarPlugin } from "@piqnt/runtime-core/playbook";

const playbook = new Playbook({
  baseUrl: "/playbook/",
});

playbook.findModules(import.meta.glob("../**/*.play.ts"));

playbook.loadModule(() => {
  const runtime = window["runtime"] as Middleware;
  if (runtime) {
    // use existing runtime
    runtime.use(new ToolbarPlugin(playbook.list));
    runtime.use(new OutlinePlugin());
  } else {
    // placeholder runtime to show toolbar
    const main = new Middleware();
    main.use(new ToolbarPlugin(playbook.list));
    window["runtime"] = main;
    Runtime.activate(main, {});
  }
});
